import { render, staticRenderFns } from "./mt4-account-binding-process.html.vue?vue&type=template&id=a5c76dce"
import script from "./mt4-account-binding-process.html.vue?vue&type=script&lang=js"
export * from "./mt4-account-binding-process.html.vue?vue&type=script&lang=js"
import style0 from "./mt4-account-binding-process.html.vue?vue&type=style&index=0&id=a5c76dce&prod&lang=scss"
import style1 from "./mt4-account-binding-process.html.vue?vue&type=style&index=1&id=a5c76dce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports